import Tooltip from 'antd/lib/tooltip';

export default Tooltip;
